
<script>
import VSelect from 'vuetify/es5/components/VSelect/VSelect'
export default {
  extends: VSelect,
  name: 'o-select-todos',
  props: {
    textoTodos: {
      type: String,
      default () {
        return this.$t('general.misc.todosSeleccionados')
      }
    }
  },
  methods: {
    genSelections () {
      let length = this.selectedItems.length
      const children = new Array(length)
      if (length === this.items.length) {
        children[0] = this.$createElement('div', this.setTextColor(false, {
          staticClass: 'v-select__selection v-select__selection--comma'
        }), this.textoTodos)
      } else {
        let genSelection
        if (this.$scopedSlots.selection) {
          genSelection = this.genSlotSelection
        } else if (this.hasChips) {
          genSelection = this.genChipSelection
        } else {
          genSelection = this.genCommaSelection
        }
        while (length--) {
          children[length] = genSelection(
            this.selectedItems[length],
            length,
            length === children.length - 1
          )
        }
      }
      return this.$createElement('div', {
        staticClass: 'v-select__selections'
      }, children)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/generic/OSelectTodos.vue